// Loghi delle gare, mostrati in dissolvenza sullo sfondo della card "pick da fare" (Home).
// La chiave e' il nome della gara normalizzato (minuscolo, solo lettere e numeri): non richiede
// modifiche al DB. Per aggiungere una gara: metti il PNG in assets/races/ (fondo trasparente, ~512 px)
// e aggiungi una riga qui sotto. Le gare senza logo restano com'erano.
const slug = (name) => String(name ?? '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '')

const LOGOS = {
  illombardia: require('../assets/races/il-lombardia.png'),
}

export const raceLogo = (name) => LOGOS[slug(name)] ?? null
